import React from "react";
import { Button } from "@mui/material";

const DownloadCarVariantsButton = () => {
 const handleDownload = async () => {
  try {
   const response = await fetch(
    "https://app-api.carexpert.org.in/api/cars/download-car-variants",
    {
     method: "GET",
    },
   );

   if (!response.ok) throw new Error("Download failed");

   const blob = await response.blob();
   const url = window.URL.createObjectURL(blob);

   const link = document.createElement("a");
   link.href = url;
   link.setAttribute("download", "car_variants.xlsx");
   document.body.appendChild(link);
   link.click();
   link.remove();
   window.URL.revokeObjectURL(url);
  } catch (err) {
   console.error("Download error:", err);
   alert("Failed to download file");
  }
 };

 return (
  <Button variant="contained" color="primary" onClick={handleDownload}>
   📥 Download Car Variants Excel
  </Button>
 );
};

export default DownloadCarVariantsButton;
